/* eslint-disable no-underscore-dangle */
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import cookie from 'js-cookie';

import {
  GRAPHQL_ENDPOINT,
  FEATURE_TOKEN_COOKIE,
  FEATURE_TOKEN_HEADER,
} from '../../../config/client.config';
import { SHOP_STORE_CODE_COOKIE } from '../../shop';
import PendingRequestCounterLink from './PendingRequestCounterLink';
import SetUserParamsLink from './SetUserParamsLink';
import LogErrorsLink from './LogErrorsLink';
import {
  possibleTypes,
  typePolicies,
  typeDefs,
  dataIdFromObject,
} from './cacheConfig';

const magento2StoreLink = new ApolloLink((operation, forward) => {
  const storeCode = cookie.get(SHOP_STORE_CODE_COOKIE);

  if (storeCode) {
    operation.setContext({ headers: { Store: storeCode } });
  }

  return forward(operation);
});

const createApolloClient = ({ history }) => {
  const cache = new InMemoryCache({
    possibleTypes,
    typePolicies,
    dataIdFromObject,
  }).restore(global.__APOLLO_STATE__);

  const httpLink = new BatchHttpLink({
    uri: GRAPHQL_ENDPOINT,
    batchInterval: 10,
    batchMax: 10,
    credentials: 'same-origin',
  });

  const authMiddlewareLink = new ApolloLink((operation, forward) => {
    const accessToken = cookie.get('access-token');
    const featureToken = cookie.get(FEATURE_TOKEN_COOKIE);

    operation.setContext({
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
        [FEATURE_TOKEN_HEADER]: featureToken || '',
      },
    });

    return forward(operation);
  });

  const pendingRequestCounterLink = new PendingRequestCounterLink();

  const setUserParamsLink = new SetUserParamsLink({ history, cache });

  const logErrorsLink = new LogErrorsLink();

  const apolloClient = new ApolloClient({
    connectToDevTools: true,
    link: ApolloLink.from([
      authMiddlewareLink,
      magento2StoreLink,
      setUserParamsLink,
      pendingRequestCounterLink,
      logErrorsLink,
      httpLink,
    ]),
    cache,
    typeDefs,
    defaultOptions: {
      query: {
        errorPolicy: 'all',
      },
    },
  });

  return { pendingRequestCounterLink, apolloClient };
};

export default createApolloClient;
